import { PRICE_TOGGLE_CHANGED } from "../constants";

export const DEFAULT_STATE = {
    currentType: null,
    availableTypes: [],
  };
  
  export const priceToggle = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
      case PRICE_TOGGLE_CHANGED:
        return {
          ...state,
          ...action.payload,
        };
      default:
        return state;
    }
  };
  